import { Box, makeStyles, Grid, Typography } from "@material-ui/core";

import { ColorIndicator } from "../colorIndicator";

const useStyles = makeStyles(() => ({
  graphItem: {
    display: "flex",
    alignItems: "center",
    "&:not(:last-child)": {
      marginRight: 15,
    },
  },
  graphItemBox: {
    width: 8,
    height: 8,
    marginRight: 4,
  },
}));
export const CustomGraphFooter = ({ items, style, typographyStyle }) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" style={{ marginTop: 26, ...style }}>
      {items.map((item, i) => (
        <Box key={i} className={classes.graphItem}>
          {item.onlyBorder ? (
            <ColorIndicator color={item.onlyBorder} onlyBorder={true} />
          ) : item.name === "Tenants Rebate" ? (
            <Box className={classes.graphItemBox} style={{ backgroundColor: item.color }}></Box>
          ) : (
            <ColorIndicator color={item.color} />
          )}
          <Box>
            <Typography style={typographyStyle}>{item.name}</Typography>
            <Typography style={{ ...typographyStyle, marginTop: 3 }}>{item.suffix}</Typography>
          </Box>
        </Box>
      ))}
    </Grid>
  );
};
